import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { WhoWeServe } from '../components/WhoWeServe';
import { Testimonials } from '../components/Testimonials';
export function WhoWeServePage() {
  return <main className="bg-white" data-id="element-575">
      <PageBanner title="Who We Serve" subtitle="Serving diverse industries and professionals across Maryland with certified fingerprinting." data-id="element-576" />
      <WhoWeServe data-id="element-577" />
      <Testimonials data-id="element-578" />
    </main>;
}